const routes = [
  {
    path: '/settings/get-service-list',
    name: 'settings/get-service-list',
    component: () => import('@/views/SuperAdmin/Services/ServiceList.vue'),
    meta: {
      requiresAuth: true,
      key: '13001',
      pageTitle: 'Services',
      breadcrumb: [
        {
          text: 'Services',
          active: false,
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]

export default routes
